import { makeStyles } from '@material-ui/core';
import { Theme } from 'enum';

export const useStyles = makeStyles((theme) => {
    const isDarkMode = theme.palette.type === Theme.Dark;

    return {
        root: {
            position: 'fixed',
            bottom: '0',
            zIndex: 101,
            width: '100%',
            display: 'flex',
            justifyContent: 'space-around',
            backgroundColor: isDarkMode ? 'rgb(30,30,30)' : 'rgb(255, 255, 255)',
            borderTop: `1px solid ${isDarkMode ? theme.palette.grey[900] : theme.palette.grey[100]}`,
            '& .MuiButton-root': {
                transition: 'none',
                padding: theme.spacing(1, 0.5),
                width: '100%',
                borderRadius: '0px',
                '& *': {
                    transition: 'none',
                },
            },
            '& .MuiButton-label': {
                display: 'flex',
                flexDirection: 'column',
                color: isDarkMode ? 'rgba(255, 255, 255, 0.6)' : 'rgba(0, 0, 0, 0.6)',

                '& .MuiButton-startIcon': {
                    marginLeft: '0px',
                    marginRight: '0px',
                },
                '& .MuiTypography-root': {
                    fontSize: theme.spacing(1.5),
                    textTransform: 'capitalize',
                },
            },
        },
        navItem: {
            flex: 1,
        },
        active: {
            '& *': {
                color: theme.palette.primary.main,
            },
        },
    };
});
